/**
 * 导航栏「马上寄件」下拉面板 — 寄件方式配置
 * 各站点寄件方式数据在此维护，pc.vue 通过 getConsignMethods(site, t) 调用
 */
import allUrls from '@/utils/config'

/**
 * 获取当前站点的寄件方式列表
 * @param {string} site - 站点编码 (cn, sg, vn, us, th, ...)
 * @param {Function} t - i18n 翻译函数 this.$t
 * @param {Object} opts - 可选项
 * @param {string} opts.lang - 当前语言 (sc/en/th 等，用于泰国站二维码区分)
 * @returns {Array} 寄件方式列表
 */
export function getConsignMethods(site, t, opts = {}) {
  // ========== US 站 ==========
  if (site === 'us') {
    return [
      {
        title: t('serviceSupport.consigns.type1Title'),
        subTitle: t('serviceSupport.consigns.descptionTitleUS1'),
        imgSrc: require('~/assets/img/consign/img_1.png'),
        imgDes: t('serviceSupport.consigns.internationalUS'),
        linkButton: t('serviceSupport.consigns.shippingBtn'),
        showUsOrderModal: true,
      },
      {
        title: t('serviceSupport.consigns.type3Title'),
        subTitle: t('serviceSupport.consigns.descptionTitle3'),
        imgSrc: require('~/assets/img/consign/qrcode_3.png'),
        imgDes: t('serviceSupport.consigns.internationalAPP'),
      },
    ]
  }

  // ========== VN 站 ==========
  if (site === 'vn') {
    return [
      {
        title: t('serviceSupport.consigns.type1Title'),
        subTitle: t('serviceSupport.consigns.descptionTitle1'),
        imgSrc: require('~/assets/img/consign/img_1.png'),
        imgDes: t('serviceSupport.consigns.international'),
        linkButton: t('serviceSupport.consigns.shippingBtn'),
        link: allUrls.iuoploginUrl,
      },
      {
        title: t('serviceSupport.consigns.type2Title'),
        subTitle: t('serviceSupport.consigns.descptionTitleVn2'),
        imgSrc: require('~/assets/img/consign/sf_go_vn.jpeg'),
        imgDes: t('serviceSupport.consigns.sfGo'),
      },
      {
        title: t('serviceSupport.consigns.type3Title'),
        subTitle: t('serviceSupport.consigns.descptionTitle3'),
        imgSrc: require('~/assets/img/consign/qrcode_3.png'),
        imgDes: t('serviceSupport.consigns.internationalAPP'),
      },
    ]
  }

  // ========== 默认 (CN / SG / TH / KR / JP / 其他) ==========
  // 泰国站二维码根据语言区分（预留，目前统一使用 qrcode_2.png）
  const wxQrcode =
    site === 'th' && opts.lang !== 'sc'
      ? require('~/assets/img/consign/qrcode_3.jpg')
      : require('~/assets/img/consign/qrcode_2.png')

  return [
    {
      title: t('serviceSupport.consigns.type1Title'),
      subTitle: t('serviceSupport.consigns.descptionTitle1'),
      imgSrc: require('~/assets/img/consign/img_1.png'),
      imgDes: t('serviceSupport.consigns.international'),
      linkButton: t('serviceSupport.consigns.shippingBtn'),
      link: allUrls.iuoploginUrl,
    },
    {
      title: t('serviceSupport.consigns.type2Title'),
      subTitle: t('serviceSupport.consigns.descptionTitle2'),
      imgSrc: wxQrcode,
      imgDes:
        site === 'th' && opts.lang !== 'sc'
          ? t('serviceSupport.consigns.wechatCodeTh')
          : t('serviceSupport.consigns.wechatCode'),
    },
    {
      title: t('serviceSupport.consigns.type3Title'),
      subTitle: t('serviceSupport.consigns.descptionTitle3'),
      imgSrc: require('~/assets/img/consign/qrcode_3.png'),
      imgDes: t('serviceSupport.consigns.internationalAPP'),
    },
  ]
}
